'use client'
import React from 'react';

interface FilterSelectProps {
  label: string;
  options: Array<{ value: string | number; label: string }>;
  onChange: (value: string | number) => void;
  value: string | number;
}

const FilterSelect: React.FC<FilterSelectProps> = ({ label, options, onChange, value }) => {
  return (
    <div className="form-group">
      <label htmlFor={label}>{label}</label>
      <select id={label} className="form-select" value={value} onChange={(e) => onChange(e.target.value) }>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FilterSelect;
